import { render, staticRenderFns } from "./ExcLogisticsInfo.vue?vue&type=template&id=ce0b9c22&scoped=true"
import script from "./ExcLogisticsInfo.vue?vue&type=script&lang=js"
export * from "./ExcLogisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./ExcLogisticsInfo.vue?vue&type=style&index=0&id=ce0b9c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0b9c22",
  null
  
)

export default component.exports